export default __webpack_public_path__ + "static/media/failed.bf51efcb.svg";